import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotifyDocumentWhenLinkedPositionCreated {
  private subject = new Subject<void | any>();

  sendMessage(data: any) {
    this.subject.next(data);
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
